import React from 'react';
import PropTypes from 'prop-types';

const MiniLoader = ({ error }) => {
  if (error) {
    return <div>Error!</div>;
  }
  return (
    <div className="mini-loader-wrapper">
      <div className="loading-circle" />
    </div>
  );
};

MiniLoader.propTypes = {
  error: PropTypes.string,
};

MiniLoader.defaultProps = {
  error: '',
};

export default MiniLoader;
